<template>
    <p class="omit">
      <slot></slot>
    </p>
</template>

<script>
export default {
  name: "index"
}
</script>

<style scoped>
    .omit{
      width: 100%;
      overflow:hidden;
      text-align: left;
      text-overflow:ellipsis;
      white-space:nowrap;
      border: 0 !important;
      background: transparent;
      padding: 0 !important;
      max-width: 500px;
    }
    .omit:hover{
      border: 0 !important;
      background: transparent;
      padding: 0 !important;
    }
</style>
